/**
 * DynaPictures Chatbot Widget Loader
 * This script loads the chatbot widget as an iframe without React dependencies.
 */

const skipAttributes = ["class", "style"];

const attrToObj = (attrs) => {
  const attrsObj = {};
  const length = attrs.length;
  for (let i = 0; i < length; i++) {
    const { name, value } = attrs[i];
    if (skipAttributes.find((item) => item === name)) {
      continue;
    }
    attrsObj[parseKey(name)] = parseValue(value);
  }
  return attrsObj;
};

const parseKey = (value) => {
  var camelCased = value.replace(/-([a-z])/g, function (g) {
    return g[1].toUpperCase();
  });
  return camelCased;
};

const parseValue = (value) => {
  if (value === "" || value === "true") {
    return true;
  }

  if (value === "false") {
    return false;
  }

  if (Number(value).toString() === value) {
    return Number(value);
  }

  return value;
};

function b64EncodeUnicode(str) {
  return btoa(encodeURIComponent(str));
}

function getClientId() {
  const storageKey = "dynapictures_chatbot_client_id";
  let clientId = localStorage.getItem(storageKey);
  if (!clientId) {
    clientId = "client_" + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    localStorage.setItem(storageKey, clientId);
  }
  return clientId;
}

// Global API for chatbot widget
if (!window.gDynaChatbotWidget) {
  window.gDynaChatbotWidget = {};
}

window.gDynaChatbotWidget.addEventListener = (eventName, callback) => {
  if (eventName === "chat_started") {
    window.addEventListener("message", function (event) {
      const { type, payload } = event.data;
      if (type === "dynapictures/widgets/chatbot/events/chat_started") {
        callback && callback(payload);
      }
    });
  }
  if (eventName === "message_sent") {
    window.addEventListener("message", function (event) {
      const { type, payload } = event.data;
      if (type === "dynapictures/widgets/chatbot/events/message_sent") {
        callback && callback(payload);
      }
    });
  }
  if (eventName === "message_received") {
    window.addEventListener("message", function (event) {
      const { type, payload } = event.data;
      if (type === "dynapictures/widgets/chatbot/events/message_received") {
        callback && callback(payload);
      }
    });
  }
};

const chatbotWidgetLoader = () => {
  const elements = document.querySelectorAll(".dynapictures-chatbot-widget");
  if (!elements) return;

  elements.forEach((el) => {
    const attrs = el.attributes;
    const props = attrToObj(attrs);

    // Convert data-* attributes to camelCase props
    for (const key in props) {
      if (key.indexOf("data") === 0 && key.length > 5) {
        const newKey = key[4].toLowerCase() + key.substring(5);
        props[newKey] = props[key];
        delete props[key];
      }
    }
    console.log("DynaPictures: Discovered chatbot widget props:", props);

    // Get the origin from script src
    const script = document.getElementById("dynapictures-chatbot-loader");
    const parser = document.createElement("a");
    parser.href = script.src;
    const origin = parser.origin;

    // Build widget params
    const clientId = getClientId();
    const pageUrl = window.location.href;

    const widgetParams = {
      ...props,
      clientId,
      pageUrl,
    };

    const encodedParams = b64EncodeUnicode(JSON.stringify(widgetParams));

    // Create iframe
    const iframe = document.createElement("iframe");
    iframe.id = "dynapictures-chatbot-frame-" + clientId;
    iframe.src = origin + "/app/widgets/chatbot?widget_params=" + encodedParams;
    iframe.style.cssText = "width: 100%; height: 100%; transition: opacity 0.5s linear; background-color: #fff; border: none;";

    // Clear and append iframe
    el.innerHTML = "";
    el.appendChild(iframe);
  });
};

// Auto-run on DOM ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", chatbotWidgetLoader);
} else {
  chatbotWidgetLoader();
}
